import { useAuth } from '@clarix/contexts';
import { AppHome } from './AppHome';

/**
 * The one Home, shared by every app. Takes NO props on purpose: with nothing to
 * vary it through, an app cannot fork the screen. Apps mount this, never
 * `AppHome` — HOME-1 in check-ui-rules.mjs fails the build on a direct import.
 * One Home means one asked-state, so the key is global, not per-app.
 */
const HOME_PERSIST_KEY = 'clarix.home.asked';

export function ClarixHome() {
  const { user } = useAuth();
  return <AppHome userName={user?.displayName} persistKey={HOME_PERSIST_KEY} />;
}
